import service from '@/utils/server';

const modName='/md/plant/';
//查询方法
export const pageInfo = data => {
  return service({
    url: modName + 'pageInfo',
    method: 'post',
    data
  });
};

export const getPlantElectric = data => {
  return service({
    url: modName + 'getPlantElectric',
    method: 'post',
    data
  });
};

export const savePlantElectric = data => {
  return service({
    url: modName + 'savePlantElectric',
    method: 'post',
    data
  });
};

export const queryPlantElectricDetail = data => {
  return service({
    url: modName + 'queryPlantElectricDetail',
    method: 'post',
    data
  });
};





// WEBPACK FOOTER //
// ./src/page/md/plant/api/index.js